import {orderBy} from 'lodash'
import fetch from 'helpers/command'
import {updateLoadableList} from 'helpers/context'
import moment from 'moment'

export async function getRollbook(context, options) {
  const {page, groupId, updateState} = context
  if (page != 'gradebook' || groupId == undefined) return 
  const clearUpdate = {
    ...updateLoadableList('rollbookContextGrades'),
    ...updateLoadableList('rollbookContextPeriods'),
    ...updateLoadableList('rollbookContextGradeColumns'),
    rollbookContextStudentAssignmentProperties: {$set: {}}
  }
  updateState(clearUpdate)
  const {grades, columns, properties, periods} = await fetchRollbook('*', context)
  const stateUpdate = {
    ...updateLoadableList('rollbookContextGrades', grades),
    ...updateLoadableList('rollbookContextPeriods', periods),
    ...updateLoadableList('rollbookContextGradeColumns', columns),
    rollbookContextStudentAssignmentProperties: {$set: properties}
  }
  updateState(stateUpdate)
}

export async function getGrades(context, refresh) {
  if (!refresh) return
  const {page, groupId, updateState} = context
  if (page != 'gradebook' || groupId == undefined) return 
  updateState(updateLoadableList('rollbookContextGrades'))
  const {grades} = await fetchRollbook('grades', context)
  updateState(updateLoadableList('rollbookContextGrades', grades))
}

export async function getStudentAssignmentProperties(context, refresh) {
    if (!refresh) return
    const {page, groupId, updateState} = context
    if (page != 'gradebook' || groupId == undefined) return 
    updateState({rollbookContextStudentAssignmentProperties: {$set: {}}})
    const {properties} = await fetchRollbook('properties', context)
    updateState({rollbookContextStudentAssignmentProperties: {$set: properties}})
}

export async function getPeriods(context, refresh) {
    if (!refresh) return
    const {page, groupId, updateState} = context
    if (page != 'gradebook' || groupId == undefined) return 
    updateState(updateLoadableList('rollbookContextPeriods'))
    const {periods} = await fetchRollbook('periods', context)
    updateState(updateLoadableList('rollbookContextPeriods', periods))
}

export async function getGradeColumns(context, refresh) {
    if (!refresh) return
    const {page, groupId, updateState} = context
    if (page != 'gradebook' || groupId == undefined) return 
    updateState(updateLoadableList('rollbookContextGradeColumns'))
    const {columns} = await fetchRollbook('columns', context)
    updateState(updateLoadableList('rollbookContextGradeColumns', columns))
}

async function fetchRollbook(target, context) {

  const {translate, groupId, gradingCategoryMap, quizTypesMap, homeworkStatus} = context
  
  const fetches = []
  
  if (target == '*' || target == 'grades') {
      fetches.push(fetch('grading', 'getGrades')({groupId}))
  }

  if (target == '*' || target == 'properties') {
      fetches.push(fetch('grading', 'getStudentAssignmentProperties')({groupId}))
  }

  if (target == '*' || target == 'columns') {
      fetches.push(fetch('grading', 'getGradeColumns')({groupId}))
  }

  if (target == '*' || target == 'periods') {
      fetches.push(fetch('grading', 'getPeriods')())
  }

  let fetchedData = {}
  
  const data = await Promise.all(fetches)

  if (target == '*') {
    const [grades, properties, columns, periods] = data
    fetchedData = {grades, properties, columns, periods}
  } else {
    fetchedData[target] = data[0]
  }

  let results = {}

  if (target == '*' || target == 'grades') {
    const processedGrades = fetchedData.grades.map(grade => {
      if (grade.type != 'homework') return grade
      const [reviewed = {}] = orderBy((grade.log || []).filter(e => homeworkStatus[e.status] == 'completed'), e => moment(e.created).valueOf(), ['desc'])
      const [turned = {}] = orderBy((grade.log || []).filter(e => homeworkStatus[e.status] == 'pending'), e => moment(e.created).valueOf(), ['desc'])
      return {...grade, finished: turned.created, points: reviewed.score || 0, notGraded: reviewed.score == undefined}
    })
    results.grades = processedGrades
  }

  if (target == '*' || target == 'properties') {
    const properties = fetchedData.properties.reduce((acc, {id, assignment, student, properties}) => {
      const students = acc[student] || (acc[student] = {})
      students[assignment] = {id, properties}
      return acc
    }, {})
    results.properties = properties
  }

  if (target == '*' || target == 'columns') {
    const typeCounts = {}
    const columnLabel = t => typeCounts[t]
      ? `${t}${++typeCounts[t]}`
      : `${t}${typeCounts[t] = 1}`
    const sortedByDate = orderBy(fetchedData.columns, [p => moment(p.start).valueOf()])
    const columns = sortedByDate.map(column => {
      const type = column.type == 'homework'
        ? 'homework'
        : column.external
          ? gradingCategoryMap[column.type]
          : quizTypesMap[column.type]
      return {...column, type, label: columnLabel(translate(`${type}-label`)[0])}
    })
    results.columns = columns
  }
  
  if (target == '*' || target == 'periods') {
    results.periods = fetchedData.periods
  }
    return results
}
    